<template>
  <div>
    <v-switch class="mt-0 mb-3"
              v-model="model"
              :true-value="false"
              :false-value="true"
              :label="schedulingLabel"
              hide-details/>
    <slot />
    <v-messages :messages="messages"/>
  </div>
</template>

<script>
import VModelBinding from '@/mixins/ModelBinding'
import VMessages from '@/components/Messages'

export default {
  name: 'SkipSchedulingField',
  mixins: [ VModelBinding ],
  components: {
    VMessages
  },
  props: {
    value: {
      required: true
    },
    userType: {
      required: true
    }
  },
  data () {
    return {
      defaultValue: false
    }
  },
  computed: {
    isCandidate () {
      return this.userType === 'Candidate'
    },
    schedulingLabel () {
      return this.model
        ? 'Tech Check will not require time slot selection (Not Recommended)'
        : 'Tech Check will require user to select time slot (Recommended)'
    },
    messages () {
      let messages = []

      if (this.isCandidate && this.model) {
        messages.push({
          color: 'warning',
          icon: 'priority_high',
          text: '<strong>This is highly unusual for candidates.</strong><br/>Please only toggle if you are absolutely sure you want to skip the time slot selection step.'
        })
      }

      return messages
    }
  },
  watch: {
    value: {
      handler () {
        if (this.value === null) {
          this.model = this.defaultValue
        }
      },
      immediate: true
    }
  }
}
</script>
